/*
  -- RETE --
  Varie funzioni di grande utilità che facilitano la gestione
  delle chiamate di rete.
*/

// Dominio.
window.dominio = window.location.host

// Dominio di primo livello.
Object.defineProperty(window, "dominio_primo_livello", {
  get: function() {
    let parti_dominio_senza_porta = window.dominio.split(":")[0].split(".")
    return parti_dominio_senza_porta[0]
  },
  enumerable: false
})

// Dominio di ultimo livello.
Object.defineProperty(window, "dominio_ultimo_livello", {
  get: function() {
    let parti_dominio_senza_porta = window.dominio.split(":")[0].split(".")
    return parti_dominio_senza_porta.slice(parti_dominio_senza_porta.length - 2).join(".")
  },
  enumerable: false
})

// Serializza un oggetto in parametri URL.
window.serializza = function(params, prefix) {
  const query = Object.keys(params).map((key) => {
    const value  = params[key];

    if (params.constructor === Array)
      key = `${prefix}[]`;
    else if (params.constructor === Object)
      key = (prefix ? `${prefix}[${key}]` : key);

    if (value == null)
      return `${key}=`
    else if (typeof value === "object")
      return serializza(value, key);
    else
      return `${key}=${encodeURIComponent(value)}`;
  });

  return [].concat.apply([], query).join("&");
}

// Legge il contenuto della risposta.
Response.prototype.content = async function() {
  let body = await this.text()

  try {
    return JSON.parse(body)
  } catch {
    return body
  }
}

// Attributi risposta.
Object.defineProperty(Response.prototype, "stato", {
  get: function() {
    return this.status
  },
  enumerable: false
})
Object.defineProperty(Response.prototype, "riuscita", {
  get: function() {
    return this.status < 400
  },
  enumerable: false
})
Object.defineProperty(Response.prototype, "fallita", {
  get: function() {
    return this.status >= 400
  },
  enumerable: false
})

////
// Retro (backend)
window.retro = {}
retro.indirizzo_statistiche = function() {
  let utente = deposito_locale.prendi("utente_corrente")

  if (!window.location.hostname.endsWith(".it"))
    return `http://ir.hbenchmark.loc:3000`

  if (utente != null && utente.abilitato_a_nuovo_motore == true)
    return `https://api.hbenchmark.it/nuovo_motore_statistiche`
  else
    return `https://l2e6kwaphza19fg1rqarvq.ir.hbenchmark.it`
}

switch (window.location.hostname) {
  case "portal.hbenchmark.it":
  case "camping.hbenchmark.it":
  case "hstaff.hbenchmark.it":
  case "bestwestern.hbenchmark.it":
  case "unahotels.hbenchmark.it":
  case "dev.hbenchmark.it":
    retro.indirizzo = `https://ir.hbenchmark.it`
    retro.indirizzo_hstaff = `https://ir-vpn.hbenchmark.it`
    break;
  case "portal.lab.hbenchmark.it":
  case "hstaff.lab.hbenchmark.it":
    retro.indirizzo = `https://ir.lab.hbenchmark.it`
    retro.indirizzo_hstaff = `https://ir.lab.hbenchmark.it`
    break;
  default:
    retro.indirizzo = `http://ir.hbenchmark.loc:3000`
    retro.indirizzo_hstaff = `http://ir.hbenchmark.loc:3000`
    break;
}

// Estremi del Retro.
retro.estremi = {
  anagrafe: {
    me:                             `${retro.indirizzo}/anagrafe/me`,
    esiste:                         `${retro.indirizzo}/anagrafe/esiste`,
    registra:                       `${retro.indirizzo}/anagrafe/registra`,
    autentica:                      `${retro.indirizzo}/anagrafe/autentica`,
    autorizza_sso:                  `${retro.indirizzo}/anagrafe/sso/autorizza`,
    password:                       `${retro.indirizzo}/anagrafe/password`
  },
  portale: {
    archivio_soggiorni:             `${retro.indirizzo}/portale/archivio_soggiorni`,
    archivi_soggiorni(id)           { return `${retro.indirizzo}/portale/archivio_soggiorni/${id}` },
    bollette:                       `${retro.indirizzo}/portale/bollette`,
    bolletta(id)                    { return `${retro.indirizzo}/portale/bollette/${id}` },
    categorie:                      `${retro.indirizzo}/portale/categorie`,
    codifiche:                      `${retro.indirizzo}/portale/codifiche`,
    concorrenti:                    `${retro.indirizzo}/portale/concorrenti`,
    concorrente(id)                 { return `${retro.indirizzo}/portale/concorrenti/${id}` },
    cruscotti:                      `${retro.indirizzo_statistiche()}/portale/cruscotti`,
    cruscotto(id)                   { return `${retro.indirizzo_statistiche()}/portale/cruscotti/${id}` },
    disponibilità:                  `${retro.indirizzo}/portale/disponibilita`,
    eventi:                         `${retro.indirizzo}/portale/eventi`,
    evento(id)                      { return `${retro.indirizzo}/portale/eventi/${id}` },
    gruppi:                         `${retro.indirizzo}/portale/gruppi`,
    indicatori:                     `${retro.indirizzo_statistiche()}/portale/indicatori`,
    indirizzo_analisi_ia(id)        { return `${retro.indirizzo}/portale/indirizzo_analisi_ia/${id}` },
    rapporti:                       `${retro.indirizzo}/portale/rapporti`,
    rapporto(id)                    { return `${retro.indirizzo}/portale/rapporti/${id}` },
    resoconti_finanziari:           `${retro.indirizzo}/portale/resoconti_finanziari`,
    resoconto_finanziario(id)       { return `${retro.indirizzo}/portale/resoconti_finanziari/${id}` },
    indice_resoconti_finanziari(id) { return `${retro.indirizzo}/portale/resoconti_finanziari/indice/${id}` },
    soggiorni:                      `${retro.indirizzo}/portale/soggiorni`,
    struttura(id)                   { return `${retro.indirizzo}/portale/strutture/${id}` },
    statistica_nuova:               `${retro.indirizzo_statistiche()}/portale/statistica`,
    statistiche:                    `${retro.indirizzo_statistiche()}/portale/statistiche`,
    statistica(id)                  { return `${retro.indirizzo_statistiche()}/portale/statistiche/${id}` },
    trasmissioni:                   `${retro.indirizzo}/portale/trasmissioni`,
    ricerca: {
      zone:                         `${retro.indirizzo}/portale/ricerca/zone`,
      località:                     `${retro.indirizzo}/portale/ricerca/localita`,
    },
  },
  licenze: {
    abbonamenti:                    `${retro.indirizzo}/licenze/abbonamenti`,
    abbonamento(id)                 { return `${retro.indirizzo}/licenze/abbonamenti/${id}` },
    buoni_sconto:                   `${retro.indirizzo}/licenze/buoni_sconto`,
    clienti:                        `${retro.indirizzo}/licenze/clienti`,
    piani:                          `${retro.indirizzo}/licenze/piani`,
    gestionali:                     `${retro.indirizzo}/licenze/gestionali`,
    pagamenti:                      `${retro.indirizzo}/licenze/pagamenti`,
    pagamento(id)                   { return `${retro.indirizzo}/licenze/pagamento/${id}` },
    strutture:                      `${retro.indirizzo}/licenze/strutture`,
    struttura(id)                   { return `${retro.indirizzo}/licenze/strutture/${id}` }
  },
  hstaff: {
    azioni:                         `${retro.indirizzo_hstaff}/hstaff/azioni`,
    eventi:                         `${retro.indirizzo_hstaff}/hstaff/eventi`,
    evento(id)                      { return `${retro.indirizzo_hstaff}/hstaff/eventi/${id}` },
    abbonamenti:                    `${retro.indirizzo_hstaff}/hstaff/abbonamenti`,
    abbonamento(id)                 { return `${retro.indirizzo_hstaff}/hstaff/abbonamenti/${id}` },
    attività:                       `${retro.indirizzo_hstaff}/hstaff/attivita`,
    attività_singola(id)            { return `${retro.indirizzo_hstaff}/hstaff/attivita/${id}` },
    bollette:                       `${retro.indirizzo_hstaff}/hstaff/bollette`,
    bolletta(id)                    { return `${retro.indirizzo_hstaff}/hstaff/bollette/${id}` },
    buoni_sconto:                   `${retro.indirizzo_hstaff}/hstaff/buoni_sconto`,
    catene:                         `${retro.indirizzo_hstaff}/hstaff/catene`,
    catena(id)                      { return `${retro.indirizzo_hstaff}/hstaff/catene/${id}` },
    chiusure:                       `${retro.indirizzo_hstaff}/hstaff/chiusure`,
    clienti:                        `${retro.indirizzo_hstaff}/hstaff/clienti`,
    cliente(id)                     { return `${retro.indirizzo_hstaff}/hstaff/clienti/${id}` },
    codifiche:                      `${retro.indirizzo_hstaff}/hstaff/codifiche`,
    concorrenti:                    `${retro.indirizzo_hstaff}/hstaff/concorrenti`,
    concorrente(id)                 { return `${retro.indirizzo_hstaff}/hstaff/concorrenti/${id}` },
    disponibilità:                  `${retro.indirizzo_hstaff}/hstaff/disponibilita`,
    disponibilità_prodotti:         `${retro.indirizzo_hstaff}/hstaff/disponibilita/prodotti`,
    gestionali:                     `${retro.indirizzo_hstaff}/hstaff/gestionali`,
    gestionale(id)                  { return `${retro.indirizzo_hstaff}/hstaff/gestionali/${id}` },
    gettone:                        `${retro.indirizzo_hstaff}/hstaff/gettone`,
    gruppi_personalizzati:          `${retro.indirizzo_hstaff}/hstaff/gruppi_personalizzati`,
    gruppo_personalizzato(id)       { return `${retro.indirizzo_hstaff}/hstaff/gruppi_personalizzati/${id}` },
    località:                       `${retro.indirizzo_hstaff}/hstaff/localita`,
    località_singola(id)            { return `${retro.indirizzo_hstaff}/hstaff/localita/${id}` },
    ricavi_negoziati:               `${retro.indirizzo_hstaff}/hstaff/ricavi_negoziati`,
    ricavo_negoziati(id)            { return `${retro.indirizzo_hstaff}/hstaff/ricavi_negoziati/${id}` },
    rifiuti:                        `${retro.indirizzo_hstaff}/hstaff/rifiuti`,
    soggiorni:                      `${retro.indirizzo_hstaff}/hstaff/soggiorni`,
    statistica:                     `${retro.indirizzo_hstaff}/hstaff/statistica`,
    strutture:                      `${retro.indirizzo_hstaff}/hstaff/strutture`,
    struttura(id)                   { return `${retro.indirizzo_hstaff}/hstaff/strutture/${id}` },
    affidabilità(id)                { return `${retro.indirizzo_hstaff}/hstaff/strutture/${id}/affidabilita` },
    associati(id)                   { return `${retro.indirizzo_hstaff}/hstaff/strutture/${id}/associati` },
    territori:                      `${retro.indirizzo_hstaff}/hstaff/territori`,
    territorio(id)                  { return `${retro.indirizzo_hstaff}/hstaff/territori/${id}` },
    totale_trasmissioni:            `${retro.indirizzo_hstaff}/hstaff/totale_trasmissioni`,
    trasmissioni:                   `${retro.indirizzo_hstaff}/hstaff/trasmissioni`,
    trasmissione(id)                { return `${retro.indirizzo_hstaff}/hstaff/trasmissioni/${id}` },
    utenti:                         `${retro.indirizzo_hstaff}/hstaff/utenti`,
    utente(id)                      { return `${retro.indirizzo_hstaff}/hstaff/utenti/${id}` },
    zone:                           `${retro.indirizzo_hstaff}/hstaff/zone`,
    zona(id)                        { return `${retro.indirizzo_hstaff}/hstaff/zone/${id}` },
    ricerca: {
      catene:                       `${retro.indirizzo_hstaff}/hstaff/ricerca/catene`,
      clienti:                      `${retro.indirizzo_hstaff}/hstaff/ricerca/clienti`,
      commesse:                     `${retro.indirizzo_hstaff}/hstaff/ricerca/commesse`,
      eventi:                       `${retro.indirizzo_hstaff}/hstaff/ricerca/eventi`,
      gestionali:                   `${retro.indirizzo_hstaff}/hstaff/ricerca/gestionali`,
      località:                     `${retro.indirizzo_hstaff}/hstaff/ricerca/localita`,
      rivenditori:                  `${retro.indirizzo_hstaff}/hstaff/ricerca/rivenditori`,
      strutture:                    `${retro.indirizzo_hstaff}/hstaff/ricerca/strutture`,
      territori:                    `${retro.indirizzo_hstaff}/hstaff/ricerca/territori`,
      utenti:                       `${retro.indirizzo_hstaff}/hstaff/ricerca/utenti`,
      zone:                         `${retro.indirizzo_hstaff}/hstaff/ricerca/zone`,
    }
  },
  best_western: {
    codifiche:                      `${retro.indirizzo}/best_western/codifiche`,
    strutture:                      `${retro.indirizzo}/best_western/strutture`,
    soggiorni:                      `${retro.indirizzo}/best_western/soggiorni`,
    lista_soggiorni(id)             { return `${retro.indirizzo}/best_western/soggiorni/${id}` }
  },
  una_hotels: {
    codifiche:                      `${retro.indirizzo}/una_hotels/codifiche`,
    strutture:                      `${retro.indirizzo}/una_hotels/strutture`
  }
}

// Chiamata di rete al Retro.
retro.chiama = async function(metodo, estremo, parametri = null, gestore = null, cappio = null) {
  let intestazioni = { "Content-Type": "application/json" }
  let gettone = biscottini.prendi("gettone")
  if (gettone != null)
    intestazioni["Authorization"] = `Bearer ${gettone}`

  let parametri_finali = { method: metodo, headers: intestazioni }

  if (cappio != null) parametri_finali.signal = cappio

  if (parametri != null) {
    if (metodo != "GET" && metodo != "HEAD" )
      parametri_finali.body = JSON.stringify(parametri)
    else
      estremo = `${estremo}?${serializza(parametri)}`
  }

  if (gestore != null) {
    return fetch(estremo, parametri_finali)
      .then(response => {
        if (!response.ok) console.error(`Errore nella chiamata a ${estremo}: ${response.status} ${response.statusText}`)
        gestore.successo({ ...response, contenuto: response.content })
      })
      .catch(error => {
        gestore.fallimento(error)
      })
  } else {
    let risposta
    await fetch(estremo, parametri_finali)
      .then(async (response) => {
        let content = await response.content()
        if (!response.ok) console.error(`Errore nella chiamata a ${estremo}: ${response.status} ${response.statusText}`)
        if (response.status == 401) throw { non_autorizzato: true }
        if (response.status == 403){
          const email_utente = deposito_locale.prendi("utente_corrente").email
          alert(`L'utente ${email_utente} non ha i permessi necessari per accedere a quest'area.`)
        }

        response.contenuto = content
        risposta = response
      })
      .catch(error => {
        if (error instanceof DOMException && error.name == "AbortError") return
        else throw error
      })

    return risposta
  }
}
